



  @if (!disableHeader) {
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button (click)="closePopup()"></ion-menu-button>
        </ion-buttons>
        <ion-title style="font-size: 13px;">
          <div class="titleBar">
            <ion-title style="font-size: 13px; text-align: left;" [ngClass]="{'adjustedTitleFont': setting.configuration.uIoptions?.homePageOption == 10}">{{ title  | translate }}</ion-title>
            <!--{{ title  | translate }}-->
            @if (NotificationService.showNotificationBell) {
              <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
                <div class="bellimgContainer">
                  <!--<fa-icon icon="bell" id="bellsize"></fa-icon>-->
                  <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                  <!--<app-app-icon [icon]="bellIcon" id="bellsize"></app-app-icon>-->
                  <!--<img id="bellsize" src="../../../../assets/icon/notification/bell.png" alt="">-->
                  @if (this.valideNotification > 0) {
                    <div class="notificationCircle">
                      <p>{{this.valideNotification}}</p>
                    </div>
                  }
                </div>
              </ion-buttons>
            }
          </div>
        </ion-title>
      </ion-toolbar>
    </ion-header>
  }


<ion-content class="content-theme-one" style="overscroll-behavior: contain;">
  
    @if ((mobile && !setting.navigationSetting) && setting.configuration.uIoptions) {
      @if (setting.configuration.uIoptions?.extendedSettings) {
        <app-undocked-navigation-bar style="position: relative; z-index: 10;"></app-undocked-navigation-bar>
      } @else {

        <app-undocked-navigation-bar style="position: relative; z-index: 10;" [disabledOption]="title"></app-undocked-navigation-bar>
      }
      
    }

    <div [ngClass]="{ 'content-push-up': isPopup }">
      <div class="selectBox">
        <div class="selectableOptionLayout">
          <button (click)="changeProfileView(true)" class="switchButtons" [ngClass]="{'selected_button': seeProfile, 'popupSwitchButtons': this.isPopup}">
            {{ "Nav.Profile" | translate | uppercase }}
          </button>
          <button (click)="changeProfileView(false)" class="switchButtons" [ngClass]="{'selected_button': !seeProfile, 'popupSwitchButtons': this.isPopup}">
            {{ "Nav.Account" | translate | uppercase }}
          </button>
        </div>
      </div>

      <!-- show the following content if it's profile-->
      @if (seeProfile) {
        <div>
          <div class="center-content">
            @if (memberProfile) {
              <ion-card [ngClass]="{'disable-box-shadow': !this.setting.UIaddBoxShadow, 'disable-background-color': !this.setting.UIshowBackground}" class="card-resizer">
                <ion-list class="disable-background-color" style="margin-bottom: 5px; padding-top: 0px">
                  <ion-list-header class="fullNameTxt resizeHeight textResizerBold">
                    {{ memberProfile.FirstName + ' ' + memberProfile.LastName }}
                  </ion-list-header>
                  <ion-item class="disable-background-color resizeHeight" disabled>
                    <a class="textResizerBold" style="color: gray;" href="mailto:{{ memberProfile.Email}}">{{memberProfile.Email}}</a>
                  </ion-item>
                  <ion-item class="disable-background-color hoveringEffect" style="cursor: pointer;" (click)="beginChangeAddress()">
                    <!--<p class="resizeMarginHeight smallTextResizer" style="white-space: pre;" [style.color]="(!memberProfile.FormattedAddress) ? 'red' : null" [style.opacity]="(!memberProfile.FormattedAddress) ? '1' : '0.3'">-->
                    <p class="resizeMarginHeight smallTextResizer" style="white-space: pre;" [style.color]="(!memberProfile.FormattedAddress) ? 'red' : null">
                      {{ memberProfile.FormattedAddress ? memberProfile.FormattedAddress : ('Profile.EnterYourAddress' | translate) }}
                    </p>
                    <ion-icon class="resizeMarginHeight" name="chevron-forward-sharp" slot="end"></ion-icon>
                  </ion-item>
                  <ion-item class="disable-background-color resizeHeight hoveringEffect" style="cursor: pointer;" (click)="onPhoneClicked()">
                    <ion-label class="resizeMarginHeight textResizerBold" [style.color]="(!phoneNumber.length) ? 'red' : null">{{ 'Profile.PhoneNumber' | translate }}
                    </ion-label>
                    <div class="smallTextResizer" item-right>{{ phoneNumber | phone }}</div>
                  </ion-item>
                  <ion-item class="disable-background-color resizeHeight hoveringEffect">
                    <ion-label class="resizeMarginHeight textResizerBold" [style.color]="(!gender) ? 'red' : null">{{ 'Profile.Gender' | translate }}</ion-label>
                    <ion-select class="resizepaddingHeight smallTextResizer" [(ngModel)]="gender" (ionChange)="updateGender()" style="max-width: 42px;">
                      <ion-select-option value="M">{{ 'Profile.Male' | translate }}</ion-select-option>
                      <ion-select-option value="F">{{ 'Profile.Female' | translate }}</ion-select-option>
                    </ion-select>
                  </ion-item>
                  <ion-item class="disable-background-color resizeHeight">
                    <ion-label class="resizeMarginHeight textResizerBold" [style.color]="(!dateOfBirth) ? 'red' : null">{{ 'Profile.DateOfBirth' | translate }}</ion-label>
                    <!--
                    <ion-datetime class="resizepaddingHeight" [disabled]="dateOfBirth" (ionChange)="updateDateOfBirth()" displayFormat="YYYY-MM-DD"
                    [max]="dateOfBirthMaxDate" [(ngModel)]="dateOfBirth"></ion-datetime>
                    -->
                    <ion-datetime-button datetime="dob" class="date-display">
                      {{ dateOfBirth | date:'yyyy-MM-dd' }}
                    </ion-datetime-button>
                    <ion-modal [keepContentsMounted]="true">
                      <ng-template>
                        <ion-datetime
                          id="dob"
                          presentation="date"
                          valueFormat="yyyy-MM-dd"
                          [disabled]="dateOfBirth"
                          [(ngModel)]="dateOfBirth"
                          (ionChange)="updateDateOfBirth()">
                        </ion-datetime>
                      </ng-template>
                    </ion-modal>
                  </ion-item>
                  <ion-item class="disable-background-color resizeHeight hoveringEffect" style="cursor:pointer;" (click)="onManageCreditCardsClicked()">
                    <ion-label class="resizeMarginHeight textResizerBold">{{ 'Profile.ManageMyCreditCards' | translate }}</ion-label>
                    <ion-icon class="resizeMarginHeight smallTextResizer" name="chevron-forward-sharp" slot="end"></ion-icon>
                  </ion-item>
                  <ion-item class="disable-background-color resizeHeight">
                    <ion-label class="resizeMarginHeight textResizerBold">{{ 'Profile.ReceiveEmails' | translate }}</ion-label>
                    <ion-toggle class="resizepaddingHeight smallTextResizer ResideToggles" (ionChange)="updateSendMail()" [(ngModel)]="sendEmail"></ion-toggle>
                  </ion-item>
                  <ion-item class="disable-background-color resizeHeight">
                    <ion-label class="resizeMarginHeight textResizerBold">{{ 'Profile.ReceiveGeolocationPromos' | translate }}</ion-label>
                    <ion-toggle class="resizepaddingHeight smallTextResizer ResideToggles" (ionChange)="updateUseGeolocation()" [(ngModel)]="useGeolocation"></ion-toggle>
                  </ion-item>
                  <ion-item class="disable-background-color resizeHeight">
                    <ion-label class="resizeMarginHeight textResizerBold">{{ 'Profile.ViewNotification' | translate}}</ion-label>
                    <ion-buttons class="ToNotificationbtn smallTextResizer" (click)="openNotificationPage()">
                      {{ 'Profile.ViewNotificationBtn' | translate}}
                    </ion-buttons>
                  </ion-item>
                  <div class="setupterms">
                    <ion-label><a style="cursor: pointer; font-size: .7rem;" (click)="showTerms($event)">{{ 'CreditCard.Agreements.Terms' | translate }}</a></ion-label>
                    <ion-label><a style="cursor: pointer; font-size: .7rem;" (click)="showPolicies($event)">{{ 'CreditCard.Agreements.Policies' | translate }}</a></ion-label>
                  </div>
                </ion-list>
                @if (isApp) {
                  <ion-button style="float:right; margin-right: 10px; margin-bottom: 10px; font-size: 8pt;" type="button" (click)="disableAccount()" color="medium">
                    {{ 'Profile.DisableAccount' | translate }}
                  </ion-button>
                }
              </ion-card>
            }
          </div>
        </div>
      }



      <!-- show this countent for the account-->
      @if (!seeProfile) {
        <div class="center-content">
          <div style="max-width: 600px;" [ngClass]="{'popupStyling': profilePopup()}">
            <ion-grid>
              <ion-row class="buttons">
                <ion-col class="button-col">
                  <ion-button  small style="width: 100%" (click)="onAddCardClicked()">
                    {{ 'Account.AddExistingCard' | translate }}
                  </ion-button>
                </ion-col>
                <ion-col class="button-col">
                  @if (canGenerateVirtualCard) {
                    <ion-button small [disabled]="reached" style="width: 100%" (click)="onGenerateCardClicked()">
                      {{ 'Account.GenerateCard' | translate }}
                    </ion-button>
                  }
                </ion-col>
              </ion-row>
            </ion-grid>
            @if (primary) {
              <ion-card [ngClass]="{'disable-box-shadow': !this.setting.UIaddBoxShadow, 'disable-background-color': !this.setting.UIshowBackground}">
                <div class="row-card">
                  <div class="important-image">
                    <div class="card-image-container">
                      <img class="card-image" [src]="getCardImage(primary)">
                      <div class="hidden-sm-up"> <ion-badge class="card-primary">{{ 'Account.Primary' | translate | lowercase }}</ion-badge></div>
                      <div class="hidden-sm-down"> <ion-badge class="card-primarySmallScreen1">{{ 'Account.Primary' | translate | lowercase }}</ion-badge></div>
                      <div class="hidden-xs-up"> <ion-badge class="card-primarySmallScreen2">{{ 'Account.Primary' | translate | lowercase }}</ion-badge></div>
                    </div>
                  </div>
                  <div class="all-info" >
                    <div class="card-information">
                      <div class="col1 card-number structure"><div>{{ 'Account.CardNumber' | translate | uppercase }}:</div></div>
                      <div class="col2 card-number structure numeric-value"><div>{{ primary.CardNumber | chunk_split: 4:' ' }}</div></div>
                    </div>
                    <!--<@if (primary.PointsBalanceValue) {-->
                      <div class="card-information">
                        <div  class="col1 card-balance structure"><div>{{ 'Account.RewardBalance' | translate | uppercase }}:</div></div>
                        <div  class="col2 card-balance structure numeric-value"><div>{{ primary.PointsBalanceValue ?? 0 | currency }}</div></div>
                      </div>
                    <!--}-->
                    <!--@if (primary.GiftBalance) {-->
                      <div style="display: flex;" class="gift-information">
                        <div class="col1 card-balance structure"><div>{{ 'Account.GiftBalance' | translate | uppercase }}:</div></div>
                        <div class="col2 card-balance structure numeric-value"><div>{{ primary.GiftBalance ?? 0 | currency }}</div></div>
                      </div>
                    <!--}-->
                    <div class="card-information">
                      <button class="scanbtn btnAccount" (click)="scanCard(primary, $event, true)">
                        {{ 'Account.ScanCard' | translate }}
                      </button>

                      <!--
                      <ion-button class="scanbtn" small (click)="scanCard(primary, $event, true)">
                        {{ 'Account.ScanCard' | translate }}
                      </ion-button>
                      -->
                    </div>
                  </div>
                </div>
                <!-- <ion-grid>
                <ion-row class="card-row">
                  <ion-col class="responsive-column" col-5>
                    <div class="card-image-container">
                      <img class="card-image" src="https://cdn.setmyapps.com/site/image?id=180">
                      <ion-badge class="card-primary">{{ 'Account.Primary' | translate | lowercase }}</ion-badge>
                    </div>
                  </ion-col>
                  <ion-col>
                    <div class="card-information">
                      <div class="card-number structure">{{ 'Account.CardNumber' | translate | uppercase }}:</div>
                      <div class="card-number structure">{{ primary.CardNumber | chunk_split: 4:' ' }}</div>
                    </div>
                    <ng-container *ngIf="primary.PointsBalanceValue">
                      <div class="card-information">
                        <div  class="card-balance structure">{{ 'Account.RewardBalance' | translate | uppercase }}:</div>
                        <div  class="card-balance structure">{{ primary.PointsBalanceValue | currency }}</div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf='primary.GiftBalance'>
                      <div style="display: flex;" class="gift-information">
                        <div class="card-balance structure"> {{ 'Account.GiftBalance' | translate | uppercase }}:</div>
                        <div class="card-balance structure">  {{ primary.GiftBalance | currency }}</div>
                      </div>
                    </ng-container>
                  </ion-col>
                </ion-row>
              </ion-grid> -->
            </ion-card>
          }
          @for (a of accounts; track a) {
            @if (!primary || a.ApiAccountId != primary.ApiAccountId) {
              <ion-card [ngClass]="{'disable-box-shadow': !this.setting.UIaddBoxShadow, 'disable-background-color': !this.setting.UIshowBackground}" (click)="onCardClicked(a)">
                <div class="row-card">
                  <div class="important-image">
                    <div class="card-image-container">
                      <img class="card-image" [src]="getCardImage(a)">
                    </div>
                  </div>
                  <div class="all-info">
                    <div class="card-information">
                      <div class="col1 card-number structure"><div>{{ 'Account.CardNumber' | translate | uppercase }}:</div></div>
                      <div class="col2 card-number structure numeric-value"><div>{{ a.CardNumber | chunk_split: 4:' ' }}</div></div>
                    </div>
                    <!--@if (a.PointsBalanceValue) {-->
                      <div class="card-information">
                        <div  class="col1 card-balance structure"><div>{{ 'Account.RewardBalance' | translate | uppercase }}:</div></div>
                        <div  class="col2 card-balance structure numeric-value"><div>{{ a.PointsBalanceValue ?? 0 | currency }}</div></div> <!-- we can also use the point balance directly if needs be-->
                      </div>
                    <!--}-->
                    <!--@if (a.GiftBalance) {-->
                      <div style="display: flex;" class="gift-information">
                        <div class="col1 card-balance structure"><div>{{ 'Account.GiftBalance' | translate | uppercase }}:</div></div>
                        <div class="col2 card-balance structure numeric-value"><div>{{ a.GiftBalance ?? 0 | currency }}</div></div>
                      </div>
                    <!--}-->
                    <div class="card-information">
                      <button class="scanbtn btnAccount" (click)="scanCard(a, $event, false)">
                        {{ 'Account.AsPrimary' | translate }}
                      </button>

                      <!--
                      <ion-button class="scanbtn" small (click)="scanCard(a, $event, false)">
                        {{ 'Account.AsPrimary' | translate }}
                      </ion-button>
                      -->
                    </div>

                    <!--
                    <div class="card-information">
                      <ion-button  style="font-size: 10px; height: 24px; width: 76px;" small (click)="scanCard(a, $event)">
                        {{ 'Account.ScanCard' | translate }}
                      </ion-button>
                    </div>
                    -->
                  </div>
                </div>
                <!-- <ion-grid>
                <ion-row class="card-row">
                  <ion-col class="responsive-column" col-7>
                    <div style="max-width: 300px;">
                      <img class="card-image" src="https://cdn.setmyapps.com/site/image?id=180">
                    </div>
                  </ion-col>
                  <ion-col>
                    <div class="card-information">
                      <div class="card-number structure">{{ 'Account.CardNumber' | translate | uppercase }}:</div>
                      <div class="card-number structure">  {{ a.CardNumber | chunk_split: 4:' ' }}</div>
                    </div>
                    <ng-container *ngIf="a.PointsBalanceValue">
                      <div class="card-information">
                        <div  class="card-balance structure">{{ 'Account.RewardBalance' | translate | uppercase }}:</div>
                        <div  class="card-balance structure">  {{ a.PointsBalanceValue | currency }}</div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf='a.GiftBalance'>
                      <div style="display: flex;"  class="gift-information">
                        <div class="card-balance structure"> {{ 'Account.GiftBalance' | translate | uppercase }}:</div>
                        <div class="card-balance structure">  {{ a.GiftBalance | currency }}</div>
                      </div>
                    </ng-container>
                  </ion-col>
                </ion-row>
              </ion-grid> -->
            </ion-card>
          }
        }
      </div>
    </div>
  }
  </div>
    
</ion-content>

